<div class="expandable-info-text__text">
  {{ showFullText() ? longText() : shortText() }}
  <p-button
    (onClick)="expandText()"
    [label]="showFullText() ? '' : ('general.more' | translate)"
    styleClass="text-decoration-underline p-0"
    link
    size="small"
    variant="text"
  />
</div>
